// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29zWq","name":"styles_name__NZMxW","phone":"styles_phone__2iUK8"};